import { api } from "./client";

export type Insight = {
  id: number;
  rule_id: string;
  priority: "high" | "medium" | "low";
  title: string;
  body: string;
  affected_user_email?: string;
  affected_department?: string;
  evidence: unknown;
  created_at: string;
  acknowledged_at: string | null;
};

export const insightsApi = {
  list: () => api.get<Insight[]>("/insights"),
};
